import * as React from 'react';

import { Tooltip } from 'antd';
import {
  Icon,
  Row,
  Space,
  Spacing,
  Text,
  TooltipPlacement,
} from 'farmhub-ui-core';

import { IconNotification, ImgSkeleton } from 'components';
import { IMAGETYPE } from 'utils';
import {
  formatImageUrl,
  genCensorshipStatus,
  getEntityInfo,
} from 'utils/function';

import {
  EntityTypeIconStylesMobile,
  ImgMobile,
  ImgWrapperMobile,
  InfoCardMobile,
  NotificationWrapperMobile,
  TextWrapperMobile,
  WrapperMobile,
} from './styles';

interface AccountMobileProps {
  item: any;
  onSelected: any;
}

// 0: 'user', 1: 'farm', 2: 'store', 3: 'collaborator', 4: 'warehouse', 5: 'transport', 6: 'volunteer'
const AccountMobile = ({
  item,
  onSelected,
}: AccountMobileProps): JSX.Element => (
  <WrapperMobile
    onClick={() =>
      onSelected({
        adminDomain: item.adminDomain,
        id: item.id,
        isOpenNewTab: item.isOpenNewTab,
        role: item.role,
        status: item.status,
        type: item.type,
        domainStatus: item.domainStatus,
        employeeStatus: item.employeeStatus,
        isSkipCheckAccess: item.isSkipCheckAccess,
      })
    }
  >
    <InfoCardMobile>
      <Row width="fit-content">
        {item.img ? (
          <ImgWrapperMobile>
            <ImgMobile
              alt="img"
              src={formatImageUrl(item.avatar, IMAGETYPE.AVATAR.xxs)}
            />
            {item.type && (
              <Tooltip
                placement={TooltipPlacement.Top}
                title={getEntityInfo(item.type).name}
              >
                <Icon
                  height="18px"
                  styles={EntityTypeIconStylesMobile}
                  width="18px"
                >
                  {getEntityInfo(item.type).icon}
                </Icon>
              </Tooltip>
            )}
          </ImgWrapperMobile>
        ) : (
          <ImgSkeleton height={64} width={64} />
        )}
        <TextWrapperMobile>
          <Text
            color="dark"
            lineHeight="18px"
            lineNumber={2}
            weight="extraBold"
          >
            {item.fullName}
          </Text>

          <Space height={2} />
          <Text color="secondary" size="xxs">
            Quyền hạn:{' '}
            <Text color="main" size="xxs">
              {item?.employeeEntityRole?.name}
            </Text>
          </Text>
        </TextWrapperMobile>
      </Row>

      <Space width={12} />
      <NotificationWrapperMobile>
        <Spacing size="small">
          <Tooltip title={genCensorshipStatus(item.status).name}>
            <div>
              <IconNotification
                background="white"
                count={0}
                icon={genCensorshipStatus(item.status, 18).icon}
                width="18px"
              />
            </div>
          </Tooltip>
        </Spacing>
      </NotificationWrapperMobile>
    </InfoCardMobile>
  </WrapperMobile>
);

export default AccountMobile;
